import React from 'react';

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Politique de cookies</h1>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Définition</h2>
          <p className="text-gray-600">
            Les cookies sont de petits fichiers stockés sur votre terminal pour faciliter la navigation et mesurer
            l’audience du site. Ils ne permettent pas de vous identifier directement.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Cookies utilisés</h2>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <li>Cookies techniques indispensables au bon fonctionnement du site.</li>
            <li>Cookies de mesure d’audience permettant d’améliorer l’expérience utilisateur.</li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Gestion des cookies</h2>
          <p className="text-gray-600">
            Lors de votre première visite, un bandeau vous permet d’accepter ou de refuser les cookies non essentiels.
            Vous pouvez modifier vos choix à tout moment via les paramètres de votre navigateur.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Contact</h2>
          <p className="text-gray-600">
            Pour toute question relative à la gestion des cookies, contactez
            <a href="mailto:Contact@artduchalet.com" className="text-[#c4d600] ml-1">Contact@artduchalet.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CookiesPage;

